module.exports = __webpack_public_path__ + "static/media/Publika 2.50741880.jpg";